<template>
  <div>
    <!-- Loader -->
    <div v-if="isLoading" class="global-loader">
      <div class="loader-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <p>Pripravujem vizualizáciu...</p>
    </div>

    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { loadAllAgents } from "./utils/userInfo.js";

export default {
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    try {
      await loadAllAgents();
    } catch (error) {
    } finally {
      this.isLoading = false; // Hide loader
    }
  },
};
</script>

<style scoped>
.global-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #1a1d29 0%, #2d3139 100%);
  font-size: 18px;
  color: #f3f4f6;
}

.loader-dots {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  justify-content: center;
  align-items: center;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ec4899, #f97316);
  animation: pulse 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

p {
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 16px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}
</style>
